import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Tooltip } from "antd";
import { ReactComponent as PendingIcon } from "../../../Assets/Icons/pendingIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../Assets/Icons/editSvg.svg";
import { ReactComponent as MapIcon } from "../../../Assets/Icons/MapIcon.svg";
import { ReactComponent as Calender } from "../../../Assets/Icons/Calender.svg";
import { ReactComponent as Clock } from "../../../Assets/Icons/Clock.svg";
import { ReactComponent as DiscountTag } from "../../../Assets/Icons/discount-tag.svg";
import { ReactComponent as RoundTick } from "../../../Assets/Icons/RoundTick.svg";
import { ReactComponent as BlueDownArrow } from "../../../Assets/Icons/blueDownArrow.svg";
import CloseIcon from "../../../Assets/Icons/CloseIconSvg.svg";
import { ReactComponent as ViewIcon } from "../../../Assets/Icons/View.svg";
import { ReactComponent as CopyIcon } from "../../../Assets/Icons/duplicateoffer.svg";
import { ReactComponent as PlusIcon } from "../../../Assets/Icons/Add.svg";
import InfoIcon from "../../../Assets/Icons/info.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import toast from "../../../utils/toast";
import { getS3PublicUrl } from "../../../utils/s3";
import "./offerList.scss";
import PrimaryButton from "../PrimaryButton";
import Confirmation from "./Confirmation";
import { useDispatch, useSelector } from "react-redux";
import RadioSelection from "../RadioSelection";
import Input from "../FormInputs";
import GenericPopup from "../GenericPopup";
import PrimaryOutlineButton from "../PrimaryOutlineButton";
import ViewCodesModal from "./ViewCodesModal";
import AddCodesModal from "./AddCodesModal";
import {
  getOfferRedemptionCodeCounts,
  updateOfferCodes,
  getOfferCodeDetails,
  editOffer,
  updateOfferHighlightStatus,
  addOfferCodes,
  updateOfferRank,
  sendOfferFeedback
} from "../../../services/offerService";
import { createOffer, getOffersByMerchant, approveOrRejectResources } from "../../../services/offerService";
import Checkbox from "../Checkbox";

var settings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: "cubic-bezier(0.16, 1, 0.3, 1)",
  autoplaySpeed: 4000,
};

const PopupContent = ({
  offerDetails,
  handleDeleteClick,
  handleEditClick,
  onClose,
  handleSingleApprovalClick,
  handleDeclineClick,
  handleStatusClick,
  onDuplicated,
}) => {
  const {
    _id,
    offerType,
    title,
    category,
    subCategory,
    tempLocations,
    description,
    ruleAndRegulation,
    startDate,
    endDate,
    startTime,
    endTime,
    discountRange,
    thumbnailImage,
    previewImages,
    status,
    necessaryRule,
    redemptionFrequency,
    merchant,
    reason,
    onlineOption,
    isHot,
    isFeatured,
    isPopular,
    offerDiscountType,
    fixedDollarAmount,
    creatorRole,
    createdBy
  } = offerDetails || {};

  // Combine thumbnail and preview images for the carousel
  const allImages = useMemo(() => {
    const images = [];
    if (thumbnailImage) images.push(thumbnailImage);
    if (Array.isArray(previewImages)) {
      previewImages.forEach(img => {
        if (img && img !== thumbnailImage) images.push(img);
      });
    }
    return images;
  }, [thumbnailImage, previewImages]);

  const resolveImageUrl = (url) => {
    return getS3PublicUrl(url);
  };

  console.log("Offer Details ==>", offerDetails);
  // Helper: parse time like "04:00 PM" or "04:00:00 PM" into minutes since midnight
  const toMinutes = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string") return null;
    const match = timeStr.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?/i);
    if (!match) return null;
    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const ampm = match[4] ? match[4].toUpperCase() : null;
    if (ampm === "PM" && hours < 12) hours += 12;
    if (ampm === "AM" && hours === 12) hours = 0;
    return hours * 60 + minutes;
  };

  // Helper: label for Redeem Once frequency (shown in popup details)
  const redeemOnceFrequencyLabel = () => {
    switch (offerDetails?.redemptionFrequency) {
      case "DAILY":
        return "Daily";
      case "IN_A_WEEK":
        return "Weekly";
      case "EVERY_30_DAYS":
        return "Monthly";
      case "EVERY_90_DAYS":
        return "Every 90 Days";
      case "EVERY_120_DAYS":
        return "Every 120 Days";
      case "ONCE_IN_12_MONTHS":
        return "Yearly";
      case "ONCE":
        return "Once";
      default:
        return null;
    }
  };

  const dispatch = useDispatch();
  const [moreClicked, setMoreClicked] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [isAdminFeedbackOpen, setIsAdminFeedbackOpen] = useState(false);
  const [isRejectionOpen, setIsRejectionOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [type, setType] = useState("");

  // Highlight offer states
  const [hotOffer, setHotOffer] = useState(isHot || false);
  const [featuredOffer, setFeaturedOffer] = useState(isFeatured || false);
  const [popularOffer, setPopularOffer] = useState(isPopular || false);

  // Track unsaved changes
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);

  // Redemption codes state
  const [showAddCodes, setShowAddCodes] = useState(false);
  const [showRedemptionCodes, setShowRedemptionCodes] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoadingCodes, setIsLoadingCodes] = useState(false);

  // Floating buttons state
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);

  // Review Status state
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Animation state for smooth modal transitions


  // Sync state with props whenever offerDetails changes
  useEffect(() => {
    if (offerDetails) {
      setHotOffer(offerDetails.isHot || false);
      setFeaturedOffer(offerDetails.isFeatured || false);
      setPopularOffer(offerDetails.isPopular || false);
      setHasUnsavedChanges(false);
    }
  }, [offerDetails]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const role = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role
  );

  const offerRedemptionCodeCounts = useSelector(
    (state) => state?.offerReducer?.offerRedemptionCodeCounts
  );
  const offerCodeDetailsFromRedux = useSelector(
    (state) => state?.offerReducer?.offerCodeDetails
  );



  const isPending = (status === "pending" || status === "PENDING");
  const isApproved = (status === "approved" || status === "APPROVED");
  const isInProcess = (role === "admin" || role === "ADMIN") && ["in-process", "in progress", "in-progress", "in process", "draft", "drafted"].includes(status?.toLowerCase()) && creatorRole?.toLowerCase() === "merchant";
  // Allow duplicate only for merchant role, not for admin
  const isMerchantRole = (role === "merchant" || role === "MERCHANT");
  // Hide duplicate icon for declined offers; allow only for approved
  const canDuplicate = isApproved && isMerchantRole;

  // Get dynamic values from Redux state
  const totalCodes = offerRedemptionCodeCounts?.totalCodes || 0;
  const usedCodes = offerRedemptionCodeCounts?.usedCodes || 0;
  const remainingCodes = offerRedemptionCodeCounts?.remainingCodes || 0;
  const usagePercentage = offerRedemptionCodeCounts?.percentageUsed || 0;

  const shouldShowReviewButton = (status === "approved" || status === "APPROVED" || status === "declined" || status === "DECLINED") && (role === "admin" || role === "ADMIN");

  const displayedRules = moreClicked
    ? ruleAndRegulation
    : ruleAndRegulation?.slice(0, 4);

  const canShowRedemptionCodes = (role === 'ADMIN' || role === 'MERCHANT' || role === 'merchant') &&
    offerType === "ONLINE_OFFER" &&
    onlineOption === "ONLINE_WITH_CODE";

  const loadOfferCodeCounts = useCallback(async () => {
    try {
      setIsLoadingCodes(true);
      console.log("PopupContent - Loading offer code counts for offerId:", _id);
      console.log("PopupContent - merchantId:", merchant?._id);

      const result = await dispatch(getOfferRedemptionCodeCounts({
        offerId: _id,
        merchantId: merchant?._id
      })).unwrap();

      console.log("PopupContent - loadOfferCodeCounts result:", result);
    } catch (error) {
      console.error("Error loading offer code counts:", error);
      setErrorMessage("Failed to load redemption code data.");
      setShowError(true);
    } finally {
      setIsLoadingCodes(false);
    }
  }, [_id, merchant?._id, dispatch]);

  const loadOfferCodeDetails = useCallback(async (page = 1, status = "") => {
    try {
      setIsLoadingCodes(true);
      const result = await dispatch(getOfferCodeDetails({
        offerId: _id,
        merchantId: merchant?._id,
        page,
        status
      })).unwrap();

      console.log("PopupContent - loadOfferCodeDetails result:", result);
    } catch (error) {
      console.error("Error loading offer code details:", error);
      setErrorMessage("Failed to load code details.");
      setShowError(true);
    } finally {
      setIsLoadingCodes(false);
    }
  }, [_id, merchant?._id, dispatch]);

  // Load redemption codes data when component mounts or offer changes
  useEffect(() => {
    if (canShowRedemptionCodes && _id) {
      loadOfferCodeCounts();
    }
  }, [_id, canShowRedemptionCodes, loadOfferCodeCounts]);

  // Auto-refresh when Redux state is cleared (after successful code addition)
  useEffect(() => {
    if (canShowRedemptionCodes && _id && offerRedemptionCodeCounts === null) {
      console.log("PopupContent - Auto-refreshing due to null state");
      loadOfferCodeCounts();
    }
  }, [offerRedemptionCodeCounts, canShowRedemptionCodes, _id, loadOfferCodeCounts]);



  const handleAddCodes = async (codesArray) => {
    try {
      console.log("handleAddCodes - Starting with codes:", codesArray);
      console.log("handleAddCodes - Codes array type:", typeof codesArray);
      console.log("handleAddCodes - Is array:", Array.isArray(codesArray));
      console.log("handleAddCodes - Codes length:", codesArray?.length);
      console.log("handleAddCodes - merchant:", merchant);
      console.log("handleAddCodes - Merchant._id:", merchant?._id);
      console.log("handleAddCodes - offer _id:", _id);

      if (!Array.isArray(codesArray) || codesArray.length === 0) {
        setErrorMessage("No valid codes provided");
        setShowError(true);
        return;
      }

      setIsLoadingCodes(true);
      setShowError(false);
      setErrorMessage("");

      const payload = {
        offerId: _id,
        offerCodes: codesArray,
        merchantId: merchant?._id
      };

      console.log("handleAddCodes - Sending payload:", payload);

      // Call the API to add codes with merchantId
      const result = await dispatch(addOfferCodes(payload)).unwrap();

      console.log("handleAddCodes - Success result:", result);
      setShowAddCodes(false);

      console.log("handleAddCodes - About to refresh data...");

      // Add a small delay to ensure the backend has processed the update
      await new Promise(resolve => setTimeout(resolve, 500));

      console.log("handleAddCodes - Refreshing offer code counts...");
      // Refresh codes data to ensure UI is updated
      await loadOfferCodeCounts();

      console.log("handleAddCodes - Refreshing offer code details...");
      // Also refresh code details for the view modal
      await loadOfferCodeDetails();

      console.log("handleAddCodes - All refreshes completed successfully");

    } catch (error) {
      console.error("handleAddCodes - Error:", error);
      console.error("handleAddCodes - Error payload:", error?.payload);
      console.error("handleAddCodes - Error response:", error?.response);

      let errorMsg = "Failed to add codes. Please try again.";

      if (error?.payload?.message) {
        errorMsg = error.payload.message;
      } else if (error?.message) {
        errorMsg = error.message;
      } else if (error?.response?.data?.message) {
        errorMsg = error.response.data.message;
      }

      setErrorMessage(errorMsg);
      setShowError(true);
    } finally {
      setIsLoadingCodes(false);
    }
  };

  const handleViewCodes = async () => {
    try {
      setIsLoadingCodes(true);
      await loadOfferCodeDetails();
      setShowRedemptionCodes(true);
    } catch (error) {
      console.error("Error loading codes for view:", error);
      setErrorMessage("Failed to load code details. Please try again.");
      setShowError(true);
    } finally {
      setIsLoadingCodes(false);
    }
  };

  const handleAddCodesFromView = async (newCodes) => {
    // Close ViewCodesModal and open AddCodesModal
    setShowRedemptionCodes(false);
    setShowAddCodes(true);
  };

  const handleFeedbackSubmit = async () => {
    try {
      if (!feedbackText || feedbackText.trim().length === 0) {
        setErrorMessage("Please enter your feedback before submitting.");
        setShowError(true);
        return;
      }
      const result = await dispatch(sendOfferFeedback({
        offerId: _id,
        feedback: feedbackText.trim(),
        merchantId: merchant?._id
      })).unwrap();
      if (result?.success) {
        setFeedbackText("");
        setIsFeedbackOpen(false);
        setErrorMessage("Feedback submitted successfully!");
        setShowError(true);
      }
    } catch (error) {
      setErrorMessage("Failed to submit feedback. Please try again.");
      setShowError(true);
    }
  };

  const handleRejectionSubmit = () => {
    if (!rejectionReason || rejectionReason.trim().length === 0) {
      setErrorMessage("Please enter a reason for rejection before submitting.");
      setShowError(true);
      return;
    }
    handleDeclineClick(offerDetails?._id, rejectionReason.trim());
    setRejectionReason("");
    setIsRejectionOpen(false);
  };

  const handleStatusChange = async (newStatus) => {
    try {
      console.log("Changing status from", status, "to", newStatus);

      if (newStatus === "approved") {
        await handleSingleApprovalClick(offerDetails?._id);
      } else if (newStatus === "declined") {
        setIsRejectionOpen(true);
      } else if (newStatus === "pending") {
        // Use the unified review status handler for pending
        handleReviewStatus();
      }
    } catch (error) {
      console.error("Error changing status:", error);
    }
  };

  const handleSaveHighlightChanges = async () => {
    try {
      console.log("Saving highlight changes:", {
        offerId: _id,
        isHot: hotOffer,
        isFeatured: featuredOffer,
        isPopular: popularOffer,
        merchantId: merchant?._id
      });

      console.log("Selected merchant:", merchant._id);
      console.log("Offer ID:", _id);

      // Call the new updateOfferHighlightStatus API
      const result = await dispatch(updateOfferRank({
        offerId: _id,
        isHot: hotOffer,
        isFeatured: featuredOffer,
        isPopular: popularOffer,
        merchantId: merchant?._id
      })).unwrap();

      console.log("API Response:", result);

      if (result?.success) {
        console.log("Highlight changes saved successfully:", result);
        setHasUnsavedChanges(false);
        // Show success message
        setErrorMessage("Highlight changes saved successfully!");
        setShowError(true);

        // Notify parent to refresh the list
        if (onDuplicated) {
          setTimeout(() => {
            try {
              onDuplicated();
            } catch (err) {
              console.error("Error calling onDuplicated after highlight save:", err);
            }
          }, 0);
        }
      } else {
        throw new Error("Failed to save highlight changes");
      }
    } catch (error) {
      console.error("Error saving highlight changes:", error);
      console.error("Error details:", error?.payload);
      console.error("Error response:", error?.response);

      let errorMsg = "Failed to save highlight changes. Please try again.";

      if (error?.payload?.message) {
        errorMsg = error.payload.message;
      } else if (error?.message) {
        errorMsg = error.message;
      } else if (error?.response?.data?.message) {
        errorMsg = error.response.data.message;
      }

      setErrorMessage(errorMsg);
      setShowError(true);
    }
  };

  // Removed duplicate radioOptions, setFieldValue, and makeHotFeatured

  // Debug logging for Redux state
  console.log("PopupContent - offerRedemptionCodeCounts:", offerRedemptionCodeCounts);
  console.log("PopupContent - offerCodeDetailsFromRedux:", offerCodeDetailsFromRedux);
  console.log("PopupContent - Calculated values:", { totalCodes, usedCodes, remainingCodes, usagePercentage });
  console.log("PopupContent - merchant:", merchant?._id);

  const handleDuplicateOffer = async () => {
    try {
      setIsDuplicating(true);
      setShowError(false);
      setErrorMessage("");

      // Validate required fields before attempting duplication
      if (!merchant?._id) {
        setErrorMessage("Merchant information is missing. Please refresh the page and try again.");
        setShowError(true);
        return;
      }

      if (!category?._id) {
        setErrorMessage("Category information is missing. Cannot duplicate offer.");
        setShowError(true);
        return;
      }

      if (!title) {
        setErrorMessage("Offer title is missing. Cannot duplicate offer.");
        setShowError(true);
        return;
      }

      // Default future scheduling to satisfy backend validation when redemption frequency/date rules exist
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const future = new Date(tomorrow);
      future.setDate(future.getDate() + 30);

      const payload = {
        merchantId: merchant?._id,
        category: category?._id,
        subCategory: Array.isArray(subCategory) ? subCategory.map((s) => s?._id).filter(id => id) : [],
        title: `Copy of ${title || "Offer"}`,
        offerType: offerType || "discount",
        offerDiscountType: offerDetails?.offerDiscountType || "percentage",
        offerCodes: Array.isArray(offerDetails?.offerCodes) ? offerDetails.offerCodes : [],
        websiteURL: offerDetails?.websiteURL || "",
        // Backend expects enum string (e.g., "ONLINE" or "ONLINE_WITH_CODE"), not boolean
        onlineOption: typeof onlineOption === "string" ? onlineOption : (offerDetails?.onlineOption || "ONLINE"),
        necessaryRule: offerDetails?.necessaryRule || "",
        ...(offerDetails?.redemptionFrequency ? { redemptionFrequency: offerDetails?.redemptionFrequency } : {}),
        // If redemption frequency is DAILY, do not provide redemptionDays to satisfy backend validation
        ...(offerDetails?.redemptionFrequency === "DAILY"
          ? {}
          : {
            redemptionDays: Array.isArray(offerDetails?.redemptionDays)
              ? offerDetails.redemptionDays
              : [],
          }),
        availableAcrossAllStores: Boolean(offerDetails?.availableAcrossAllStores),
        discountRange: Number(discountRange) || 0,
        fixedDollarAmount: Number(offerDetails?.fixedDollarAmount) || 0,
        thumbnailImage: offerDetails?.thumbnailImage || "",
        previewImages: Array.isArray(previewImages) ? previewImages : [],
        description: description || "",
        redemptionMethod: offerDetails?.redemptionMethod || "qr_code",
        // Only include startDate/endDate if redemption frequency is not CONTINUALLY
        ...(offerDetails?.redemptionFrequency !== "CONTINUALLY" && {
          startDate: tomorrow.toISOString(),
          endDate: future.toISOString(),
          startTime: null,
          endTime: null,
        }),
        callback_url: offerDetails?.callback_url || "",
        ruleAndRegulation: Array.isArray(ruleAndRegulation) ? ruleAndRegulation.map((r) => r?._id).filter(id => id) : [],
        locations: Array.isArray(tempLocations) ? tempLocations.map((l) => l?._id).filter(id => id) : [],
        discountTitle: offerDetails?.discountTitle || "",
        isCreated: false,
        status: "drafted",
      };

      console.log("Duplicating offer with payload:", payload);

      // For duplication, we create a new offer (no offerId parameter)
      const res = await dispatch(createOffer(payload)).unwrap();
      console.log("Duplicate response:", res);

      if (res?.success) {
        // Show success message
        console.log("Offer duplicated successfully");
        toast.success("Offer duplicated successfully!");
        // Ask parent to refresh list using its current filters; defer to avoid nested dispatch during reducers
        try { if (onDuplicated) setTimeout(() => { try { onDuplicated(); } catch { } }, 0); } catch { }
        onClose?.();
      } else {
        const errorMsg = res?.message || res?.error || "Failed to duplicate the offer";
        console.error("Duplication failed:", errorMsg, res);
        setErrorMessage(errorMsg);
        setShowError(true);
      }
    } catch (error) {
      console.error("Duplication error:", error);
      const errorMsg = error?.payload?.message || error?.response?.data?.message || error?.message || "Failed to duplicate the offer";
      setErrorMessage(errorMsg);
      setShowError(true);
    } finally {
      setIsDuplicating(false);
    }
  };

  // Handle scroll to show/hide floating buttons
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

    // Show floating buttons when scrolled down more than 70%
    setShowFloatingButtons(scrollPercentage > 0.7);
  };

  // Show floating buttons immediately for pending offers
  useEffect(() => {
    if (isPending && (role === "admin" || role === "ADMIN")) {
      setShowFloatingButtons(true);
    }
  }, [isPending, role]);

  // Review Status handlers
  const handleShowReviewModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    setShowReviewModal(false);
  };

  const handleReviewStatus = async () => {
    try {
      if (handleStatusClick) {
        await handleStatusClick(_id, "pending");
        setShowReviewModal(false);
        onClose?.();
      } else {
        // Fallback if prop not provided
        const payload = {
          type: "offer",
          status: "pending",
          ids: [_id],
          merchantId: merchant?._id,
          TextBody: `Your offer "${title}" has been moved back to Pending for review.`,
          HtmlBody: `<p>Your offer <strong>${title}</strong> has been moved back to <strong>Pending</strong> for review.</p>`,
        };
        const statusPromise = await dispatch(approveOrRejectResources(payload))?.unwrap();
        if (statusPromise?.success === true) {
          setShowReviewModal(false);
          if (onDuplicated) onDuplicated();
          onClose?.();
        }
      }
    } catch (error) {
      console.error("Error setting offer status to pending:", error);
      setErrorMessage("Failed to update status. Please try again.");
      setShowError(true);
    }
  };

  if (!offerDetails) {
    return (
      <div className="relative">
        <button
          onClick={onClose}
          className="absolute -top-4 -right-2 md:-top-6 md:-right-6 w-[32px] h-[32px] md:w-[40px] md:h-[40px] cursor-pointer z-[60]"
        >
          <img src={CloseIcon} alt="Close" className="w-full h-full" />
        </button>

        <div className="bg-white rounded-lg shadow-lg mx-auto w-[95vw] md:w-[900px] min-h-[400px] md:min-h-[600px] flex flex-col items-center justify-center">
          <div className="loader"></div>
          <p className="mt-4 text-[#767676] font-poppins text-[14px] md:text-[15px]">Loading offer details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">

      {/* Close Button - Positioned outside the modal */}
      <button
        onClick={() => {
          if (hasUnsavedChanges) {
            setShowUnsavedChangesModal(true);
          } else {
            onClose();
          }
        }}
        className="absolute -top-4 -right-2 md:-top-6 md:-right-6 w-[32px] h-[32px] md:w-[40px] md:h-[40px] cursor-pointer z-[60]"
      >
        <img src={CloseIcon} alt="Close" className="w-full h-full" />
      </button>

      {/* Main PopupContent - Hide when other modals are open */}
      {!showRedemptionCodes && !showAddCodes && (
        <div className="bg-white rounded-lg shadow-lg mx-auto w-[95vw] sm:w-[90vw] md:w-[900px] relative overflow-hidden">
          <div
            className="max-h-[88vh] md:max-h-[88vh] overflow-y-auto scrollbar-hidden min-h-[400px] md:min-h-[550px]"
            onScroll={handleScroll}
          >
            {isDuplicating && (
              <div className="sticky top-0 left-0 right-0 z-10">
                <div className="w-full bg-[#E6F8FF] text-[#00ADEF] text-center py-2 text-sm">Copying offer...</div>
              </div>
            )}
            {showError && (
              <GenericPopup
                icon={InfoIcon}
                content={errorMessage}
                popupClassName="w-[335px] sm:w-[470px] pb-8"
                continueBtn={
                  <PrimaryOutlineButton
                    label="Close"
                    className="sm:w-[30%] md:w-[35%] lg:w-[35%] font-poppins sm:text-[12px] md:text-[14px] text-center font-[500] sm:h-[35px] md:h-[40px] rounded-[10px] mt-5"
                    onClick={() => setShowError(false)}
                  />
                }
              />
            )}

            {isRejectionOpen ? (
              <div className="p-6">
                <div className="w-full flex justify-between items-center mb-4">
                  <h1 className="font-[600] text-[24px]">{title}</h1>
                  <div className="flex items-center gap-4">
                    <Confirmation
                      status={status}
                      creatorRole={creatorRole}
                      showInProcess={role === "admin" || role === "ADMIN"}
                    />
                  </div>
                </div>

                {previewImages?.length > 0 && (
                  <div className="mb-6">
                    {previewImages?.length === 1 ? (
                      <div className="w-full h-[200px] rounded-lg overflow-hidden">
                        <img
                          src={process.env.REACT_APP_S3_URL + previewImages[0]}
                          alt="offerPreview"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <Slider className="w-full h-[200px] custom-carousel" {...settings}>
                        {previewImages?.map((url, idx) => (
                          <img
                            key={idx}
                            src={process.env.REACT_APP_S3_URL + url}
                            alt="offerPreview"
                            className="w-full h-[200px] object-cover"
                          />
                        ))}
                      </Slider>
                    )}
                  </div>
                )}

                <div className="flex flex-col items-center gap-6">
                  <div className="flex flex-col items-center gap-3">
                    <h2 className="text-[24px] font-[600] text-[#303030]">
                      Offer Rejection Reason
                    </h2>
                    <div className="text-[16px] font-[400] text-[#8C8C8C] text-center max-w-[600px]">
                      <p>Could you please provide the reason for the</p>
                      <p>rejection of this offer?</p>
                    </div>
                  </div>

                  <div className="w-full">
                    <textarea
                      className="w-full h-[150px] border border-[#E5E7EB] rounded-lg p-4 resize-none focus:outline-none focus:border-[#00ADEF] text-[#303030]"
                      placeholder="Reason for Rejection"
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex justify-center gap-4 mt-4">
                  <button
                    className="px-6 py-2 rounded-[5px] text-[14px] font-[600] text-[#00ADEF] border border-[#00ADEF] hover:bg-[#E6F8FF] min-w-[120px]"
                    onClick={() => setIsRejectionOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-6 py-2 rounded-[5px] text-[14px] font-[600] text-white bg-[#00ADEF] hover:bg-[#33bdf1] min-w-[120px]"
                    onClick={handleRejectionSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            ) : !isFeedbackOpen ? (
              <div className="p-6 pb-28">
                {/* Header Section */}
                <div className="flex justify-between items-start mb-4 gap-4">
                  <div className="flex-1 min-w-0">
                    <h1 className="text-lg md:text-xl font-bold text-gray-900 mb-1 truncate" title={title}>
                      {title}
                    </h1>
                    {(role === "admin" || role === "ADMIN") && creatorRole && window.location.pathname === "/offer-list" && (
                      <div className="bg-[#FFF4E5] text-[#B76E00] px-3 py-0.5 rounded-full text-[10px] font-semibold border border-[#FFE7C1] w-fit mb-2">
                        CREATED BY: {creatorRole === "admin" ? (createdBy?.name || "ADMIN") : (merchant?.businessName || "MERCHANT")}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col md:flex-row items-end md:items-center gap-2 md:gap-3 flex-shrink-0">
                    <div className="flex items-center gap-3">
                      {shouldShowReviewButton && (
                        <button
                          onClick={handleShowReviewModal}
                          className="px-3 py-1 border border-[#00ADEF] text-[#00ADEF] bg-transparent rounded-[4px] hover:bg-[#00ADEF] hover:text-white font-medium text-sm transition-colors whitespace-nowrap"
                        >
                          Review Status
                        </button>
                      )}
                      <Confirmation
                        status={status}
                        onStatusClick={handleStatusChange}
                        offerId={_id}
                        enablePendingAction={role === "admin" || role === "ADMIN"}
                        showInProcess={role === "admin" || role === "ADMIN"}
                        creatorRole={creatorRole}
                      />
                    </div>
                    <div className="flex items-center gap-3 md:gap-2">
                      {!isInProcess && (
                        <Tooltip title="Delete Offer" color="#00ADEF" trigger={isMobile ? [] : ["hover"]}>
                          <DeleteIcon
                            className="w-4 h-4 text-gray-400 hover:text-red-500 cursor-pointer"
                            onClick={() => handleDeleteClick(offerDetails)}
                          />
                        </Tooltip>
                      )}
                      {canDuplicate && (
                        <Tooltip title="Duplicate Offer" color="#00ADEF" trigger={isMobile ? [] : ["hover"]}>
                          <CopyIcon
                            className={`w-5 h-5 relative top-[1px] ${isDuplicating ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                            onClick={!isDuplicating ? handleDuplicateOffer : undefined}
                          />
                        </Tooltip>
                      )}
                      {status !== "approved" && !isInProcess && (
                        <Tooltip title="Edit Offer" color="#00ADEF" trigger={isMobile ? [] : ["hover"]}>
                          <EditIcon
                            className="w-4 h-4 text-gray-400 hover:text-blue-500 cursor-pointer"
                            onClick={() => handleEditClick(offerDetails?._id)}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>

                {/* Image Carousel */}
                {allImages.length > 0 && (
                  <div className="relative mb-4">
                    {allImages.length === 1 ? (
                      <div className="w-full h-[200px] rounded-lg overflow-hidden">
                        <img
                          src={resolveImageUrl(allImages[0])}
                          alt="offerPreview"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <div className="w-full mb-8 relative">
                        <Slider {...settings} className="custom-carousel">
                          {allImages.map((url, idx) => (
                            <div key={idx} className="w-full h-[200px] outline-none">
                              <div className="w-full h-full rounded-lg overflow-hidden">
                                <img
                                  src={resolveImageUrl(url)}
                                  alt="offerPreview"
                                  className="w-full h-full object-cover"
                                />
                              </div>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    )}
                  </div>
                )}

                {/* Offer Type and Categories */}
                <div className="mb-4">
                  {offerType && (
                    <div className="bg-[#00ADEF] text-white px-2 py-1 rounded-full text-xs font-medium mb-2 inline-block">
                      {offerType === "INSTORE_SWOODLE_OFFER"
                        ? "INSTORE SWOODLE OFFER"
                        : offerType === "ONLINE_OFFER"
                          ? "ONLINE OFFER"
                          : offerType}
                    </div>
                  )}
                  <div className="flex flex-wrap gap-1">
                    {subCategory?.map((option, index) => (
                      <div
                        key={index}
                        className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium"
                      >
                        {option?.title}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Offer Details */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                  {startDate && endDate && (
                    <div className="flex items-center gap-2">
                      <Calender className="w-4 h-4 text-[#00ADEF]" />
                      <span className="text-gray-700 text-sm">
                        {separateDateTimeAndConvertToLocale(startDate)?.localDate} to{" "}
                        {separateDateTimeAndConvertToLocale(endDate)?.localDate}
                      </span>
                    </div>
                  )}
                  {endTime !== null && startTime !== null && (
                    <div className="flex items-center gap-1">
                      <Clock className="w-5 h-5 text-[#00ADEF] relative -left-[2px]" />
                      <span className="text-gray-700 text-sm">
                        {startTime} to {endTime}
                      </span>
                    </div>
                  )}
                  {offerDiscountType && (
                    <div className="flex items-center gap-2">
                      <DiscountTag className="w-4 h-4 text-[#00ADEF]" />
                      <span className="text-gray-700 text-sm">
                        {(() => {
                          switch (offerDiscountType) {
                            case "FREE_OFFER":
                              return "Free Offer";
                            case "DISCOUNTED_PERCENT":
                              return `Discounted Offer (${discountRange}%)`;
                            case "FIXED_DOLLAR":
                              return `Fixed Dollar Offer ($${fixedDollarAmount || 0})`;
                            case "BUY_ONE_GET_ONE_FREE":
                              return "Buy One Get One Free";
                            case "BUNDLE_OFFER":
                              return "Bundle Offer";
                            default:
                              return offerDiscountType;
                          }
                        })()}
                      </span>
                    </div>
                  )}
                  {necessaryRule && (
                    <div className="flex items-center gap-2">
                      <RoundTick className="w-4 h-4 text-[#00ADEF]" />
                      <span className="text-gray-700 text-sm">
                        {necessaryRule === "REDEEM_ONCE"
                          ? `Redeem Once${redeemOnceFrequencyLabel() ? ` (${redeemOnceFrequencyLabel()})` : ""}`
                          : necessaryRule === "OFFER_AVAILABLE_THROUGHOUT_YEAR"
                            ? "Offer Available Throughout Year"
                            : necessaryRule === "CHOOSE_DATE_RANGE"
                              ? "Choose a Date Range"
                              : null}
                      </span>
                    </div>
                  )}
                </div>

                {/* Description */}
                {description && (
                  <div className="space-y-1 mb-4">
                    <h3 className="font-semibold text-gray-900 text-sm">Offer Description:</h3>
                    <p className="text-gray-700 leading-relaxed text-sm" style={{ whiteSpace: "pre-line" }}>
                      {String(description || "").replace(/\r\n/g, "\n").replace(/\n{2,}/g, "\n")}
                    </p>
                  </div>
                )}

                {/* Rules & Regulations */}
                {ruleAndRegulation?.length > 0 && (
                  <div className="space-y-2 mb-4">
                    <h3 className="font-semibold text-gray-900 text-sm">Rules & Regulations:</h3>
                    <ul className="space-y-1">
                      {displayedRules?.map((rule, index) => (
                        <li key={index} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 bg-[#00ADEF] rounded-full mt-1.5 flex-shrink-0"></div>
                          <span className="text-gray-700 text-sm">{rule?.title}</span>
                        </li>
                      ))}
                    </ul>
                    {ruleAndRegulation?.length > 4 && (
                      <button
                        className="flex items-center gap-1 text-[#00ADEF] hover:text-[#0098d1] font-medium text-sm"
                        onClick={() => setMoreClicked(!moreClicked)}
                      >
                        <span>Show {moreClicked ? "Less" : "More"}</span>
                        <BlueDownArrow className={`w-3 h-3 transition-transform ${moreClicked ? "rotate-180" : ""}`} />
                      </button>
                    )}
                  </div>
                )}

                {/* Highlight Offer as: - Hide for drafted offers */}
                {status !== "drafted" && status !== "DRAFTED" && (
                  <div className="space-y-2 mb-4">
                    <h3 className="font-semibold text-gray-900 text-sm">Highlight Offer as:</h3>
                    {(role === "admin" || role === "ADMIN") ? (
                      <>
                        <div className="flex items-center gap-2">
                          <Checkbox
                            divClassName="flex items-center gap-2"
                            text="Featured Offer"
                            checked={featuredOffer}
                            onChecked={() => {
                              const newValue = !featuredOffer;
                              setFeaturedOffer(newValue);
                              // Check if both values match original values
                              const hasChanges = newValue !== (isFeatured || false) || popularOffer !== (isPopular || false);
                              setHasUnsavedChanges(hasChanges);
                            }}
                            textClass="text-gray-700 text-sm"
                            checkClassName="!w-[18px] !h-[18px]"
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <Checkbox
                            divClassName="flex items-center gap-2"
                            text="Popular Offer"
                            checked={popularOffer}
                            onChecked={() => {
                              const newValue = !popularOffer;
                              setPopularOffer(newValue);
                              // Check if both values match original values
                              const hasChanges = featuredOffer !== (isFeatured || false) || newValue !== (isPopular || false);
                              setHasUnsavedChanges(hasChanges);
                            }}
                            textClass="text-gray-700 text-sm"
                            checkClassName="!w-[18px] !h-[18px]"
                          />
                        </div>
                      </>
                    ) : (
                      <p className="text-gray-500 text-sm">Role: {role} - Admin access required</p>
                    )}
                  </div>
                )}

                {/* Dynamic Redemption Codes Section */}
                {canShowRedemptionCodes && (
                  <div className="pt-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-3 gap-2">
                      <h3 className="text-base font-semibold text-gray-900">Redemption Codes</h3>
                      <div className="flex flex-wrap gap-2 w-full sm:w-auto">
                        <button
                          onClick={handleViewCodes}
                          disabled={isLoadingCodes}
                          className="flex-1 sm:flex-initial flex items-center justify-center gap-1 px-3 py-2 border border-[#00ADEF] text-[#00ADEF] hover:bg-[#E6F8FF] text-xs font-medium rounded-[4px] disabled:opacity-50"
                        >
                          <ViewIcon className="w-4 h-4" />
                          {isLoadingCodes ? "Loading..." : "View codes"}
                        </button>
                        <button
                          onClick={() => setShowAddCodes(true)}
                          disabled={isLoadingCodes}
                          className="flex-1 sm:flex-initial flex items-center justify-center gap-1 px-3 py-2 border border-[#00ADEF] text-[#00ADEF] hover:bg-[#E6F8FF] text-xs font-medium rounded-[4px] disabled:opacity-50"
                        >
                          <PlusIcon className="w-4 h-4" />
                          Add codes
                        </button>
                      </div>
                    </div>

                    <div className="mb-3">
                      <div className="text-base font-semibold text-gray-700 mb-1">
                        {usagePercentage}% Used out of {totalCodes}
                      </div>

                      {/* Progress Bar */}
                      <div className="w-full bg-gray-200 rounded-full h-2 mb-3">
                        <div
                          className="bg-yellow-400 h-2 rounded-full transition-all duration-300"
                          style={{ width: `${usagePercentage}%` }}
                        ></div>
                      </div>

                      {/* Statistics */}
                      <div className="flex gap-4 text-xs">
                        <div className="flex items-center gap-1">
                          <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                          <span>Used Codes: {usedCodes}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                          <span>Remaining Codes: {remainingCodes}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="p-6">
                <div className="w-full flex justify-between items-center mb-4">
                  <h1 className="font-[600] text-[24px]">{title}</h1>
                  <div className="flex items-center gap-4">
                    <Confirmation
                      status={status}
                      creatorRole={creatorRole}
                      showInProcess={role === "admin" || role === "ADMIN"}
                    />
                  </div>
                </div>

                {previewImages?.length > 0 && (
                  <div className="mb-6">
                    {previewImages?.length === 1 ? (
                      <div className="w-full h-[200px] rounded-lg overflow-hidden">
                        <img
                          src={resolveImageUrl(previewImages[0])}
                          alt="offerPreview"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <Slider className="w-full h-[200px] custom-carousel" {...settings}>
                        {previewImages?.map((url, idx) => (
                          <div key={idx} className="w-full h-[200px]">
                            <img
                              src={resolveImageUrl(url)}
                              alt="offerPreview"
                              className="w-full h-full object-cover rounded-lg"
                            />
                          </div>
                        ))}
                      </Slider>
                    )}
                  </div>
                )}

                <div className="flex flex-col items-center gap-6">
                  <div className="flex flex-col items-center gap-3">
                    <h2 className="text-[24px] font-[600] text-[#303030]">
                      Feedback
                    </h2>
                    <div className="text-[16px] font-[400] text-[#8C8C8C] text-center max-w-[600px]">
                      <p>Please share your feedback to help the merchant</p>
                      <p>improve the offer.</p>
                    </div>
                  </div>

                  <div className="w-full">
                    <textarea
                      className="w-full h-[150px] border border-[#E5E7EB] rounded-lg p-4 resize-none focus:outline-none focus:border-[#00ADEF] text-[#303030]"
                      placeholder="Feedback"
                      value={feedbackText}
                      onChange={(e) => setFeedbackText(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex justify-center gap-4 mt-4">
                  <button
                    className="px-6 py-2 rounded-[5px] text-[14px] font-[600] text-[#00ADEF] border border-[#00ADEF] hover:bg-[#E6F8FF] min-w-[120px]"
                    onClick={() => setIsFeedbackOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-6 py-2 rounded-[5px] text-[14px] font-[600] text-white bg-[#00ADEF] hover:bg-[#33bdf1] min-w-[120px]"
                    onClick={handleFeedbackSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Floating Action Buttons for Pending Offers - Now inside the unified wrapper */}
          {(role === "admin" || role === "ADMIN") && isPending && showFloatingButtons && !showRedemptionCodes && !showAddCodes && !isFeedbackOpen && !isRejectionOpen && !showUnsavedChangesModal && !showError && !showReviewModal && (
            <div className="absolute bottom-0 left-0 right-0 bg-white p-6 z-10 border-t border-gray-100 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] rounded-b-lg">
              <div className="flex flex-col md:flex-row justify-between items-stretch md:items-center gap-4">
                <button
                  className={`px-4 py-2.5 rounded-[4px] font-semibold text-sm transition-colors ${!hasUnsavedChanges
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "bg-[#00ADEF] text-white hover:bg-[#0098d1]"
                    }`}
                  onClick={handleSaveHighlightChanges}
                  disabled={!hasUnsavedChanges}
                >
                  Save Changes
                </button>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                  <button
                    className="text-[#00ADEF] hover:text-[#0098d1] font-semibold text-sm py-2 px-4 border border-[#00ADEF] sm:border-none rounded-[4px]"
                    onClick={() => setIsFeedbackOpen(true)}
                  >
                    Share Feedback
                  </button>
                  <div className="flex items-center gap-3">
                    <button
                      className="flex-1 px-6 py-2.5 border border-red-500 text-red-500 rounded-[4px] hover:bg-red-500 hover:text-white font-semibold text-sm min-w-[100px] transition-colors"
                      onClick={() => setIsRejectionOpen(true)}
                    >
                      Decline
                    </button>
                    <button
                      className="flex-1 px-6 py-2.5 bg-[#00ADEF] text-white rounded-[4px] hover:bg-[#0098d1] font-semibold text-sm min-w-[100px]"
                      onClick={() => handleSingleApprovalClick(offerDetails?._id)}
                    >
                      Approve
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Floating Action Buttons for APPROVED Offers with Unsaved Changes */}
          {(role === "admin" || role === "ADMIN") && isApproved && hasUnsavedChanges && !showRedemptionCodes && !showAddCodes && !isFeedbackOpen && !isRejectionOpen && !showUnsavedChangesModal && !showError && !showReviewModal && (
            <div className="absolute bottom-0 left-0 right-0 bg-white p-6 z-10 border-t border-gray-100 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] rounded-b-lg">
              <div className="flex flex-col md:flex-row justify-end items-center gap-4">
                <button
                  className="px-6 py-2.5 rounded-[4px] font-semibold text-sm transition-colors text-gray-500 hover:text-gray-700 bg-gray-100 hover:bg-gray-200"
                  onClick={() => {
                    setFeaturedOffer(isFeatured || false);
                    setPopularOffer(isPopular || false);
                    setHasUnsavedChanges(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="px-6 py-2.5 rounded-[4px] font-semibold text-sm transition-colors bg-[#00ADEF] text-white hover:bg-[#0098d1]"
                  onClick={handleSaveHighlightChanges}
                >
                  Save Changes
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Dynamic Redemption Codes Modal */}
      {showRedemptionCodes && (
        <ViewCodesModal
          onClose={() => setShowRedemptionCodes(false)}
          codes={offerCodeDetailsFromRedux?.codes || []}
          usedCount={usedCodes}
          totalCount={totalCodes}
          onAddCodes={handleAddCodesFromView}
          offerId={_id}
          merchantId={merchant?._id}
        />
      )}

      {/* Add Codes Modal */}
      {showAddCodes && (
        <AddCodesModal
          onClose={() => setShowAddCodes(false)}
          onAddCodes={handleAddCodes}
          offerId={_id}
          merchantId={merchant?._id}
        />
      )}

      {/* Unsaved Changes Confirmation Modal */}
      {showUnsavedChangesModal && (
        <GenericPopup
          icon={InfoIcon}
          content="You have unsaved changes to the highlight offer settings. Are you sure you want to close without saving?"
          popupClassName="w-[335px] sm:w-[480px] pb-8"
          continueBtn={
            <PrimaryOutlineButton
              label="Save Changes"
              className="sm:w-[38%] md:w-[38%] lg:w-[38%] font-poppins sm:text-[12px] md:text-[14px] text-center font-[500] sm:h-[38px] md:h-[42px] rounded-[10px] mt-5"
              onClick={async () => {
                await handleSaveHighlightChanges();
                setShowUnsavedChangesModal(false);
                onClose();
              }}
            />
          }
          cancelBtn={
            <PrimaryOutlineButton
              label="Close Without Saving"
              className="sm:w-[38%] md:w-[38%] lg:w-[38%] font-poppins sm:text-[11px] md:text-[13px] text-center font-[500] sm:h-[38px] md:h-[42px] rounded-[10px] mt-5 bg-red-500 hover:bg-red-600 text-white !border-red-500 hover:!border-red-600"
              onClick={() => {
                setShowUnsavedChangesModal(false);
                onClose();
              }}
            />
          }
        />
      )}

      {/* Floating Action Buttons moved up inside the wrapper */}

      {/* Review Status Modal */}
      {showReviewModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[400px] mx-4">
            <h2 className="text-xl font-semibold mb-4">Review Status</h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to change the status of this offer to "Pending"?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={handleCloseReviewModal}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-[4px] hover:bg-gray-50 font-medium text-sm transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleReviewStatus}
                className="px-4 py-2 bg-[#00ADEF] text-white rounded-[4px] hover:bg-[#0088CC] font-medium text-sm transition-colors"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PopupContent;